import React from 'react';
function BodyFatTable({ result }) {
  return (
    <div>
      <div>
        <table >
          <thead>
            <tr>
              <th >الحالة </th>
              <th >النسبة</th>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td>نسبة الدهون:</td>
              <td>{result.bodyFatPercentage} %</td>
            </tr>
            <tr >
              <td>	كتلة الدهون</td>
              <td>{result.fatMass} كغ</td>
            </tr>
            <tr >
              <td>الكتلة العضيلية النّقية</td>
              <td>{result.leanMass} كغ</td>
            </tr>
            <tr >
              <td>تصنيف الدهون في الجسم</td>
              <td>{result.bodyFatCategory}</td>
            </tr>
            {result.idealBodyFatPercentage !== 0 && (
              <>
                <tr>
                  <td>نسبة الدهون المثالية في الجسم:</td>
                  <td>{result.idealBodyFatPercentage} %</td>
                </tr>
                <tr>
                  <td>الدهون المطلوبة للوصول إلى المستوى المثالي:</td>
                  <td>{result.bodyFatToLose} كغ</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
        <br />
        <hr />
        <div>
          <table >
            <thead>
              <tr>
                <th >التصنيف </th>
                <th >ذكر</th>
                <th >أنثى </th>
              </tr>
            </thead>
            <tbody>
              <tr className={result.bodyFatCategory === 'Essential Fat' ? 'highlightedOk' : ''}>
                <td>الدهون الأساسية (Essential Fat)</td>
                <td>2-5%</td>
                <td>10-13%</td>
              </tr>
              <tr className={result.bodyFatCategory === 'Athletes' ? 'highlightedOk' : ''}>
                <td>الرياضيين (Athletes)</td>
                <td>	6-13%</td>
                <td>14-20%</td>
              </tr>
              <tr className={result.bodyFatCategory === 'Fitness' ? 'highlightedOk' : ''}>
                <td> لياقة بدنية (Fitness)</td>
                <td>14-17%</td>
                <td>21-24%</td>
              </tr>
              <tr className={result.bodyFatCategory === 'Acceptable' ? 'highlightedOk' : ''}>
                <td>مقبول (Acceptable)</td>
                <td>18-24%</td>
                <td>25-31%</td>
              </tr>
              <tr className={result.bodyFatCategory === 'Obese' ? 'highlightedDanger' : ''}>
                <td>سمنة (Obese)</td>
                <td>+ 25%</td>
                <td>+ 32%</td>
              </tr>
              <tr>
                <td colSpan="3">
                  <b>المصدر:</b>{' '}
                  <a href="https://www.acefitness.org/resources/everyone/tools-calculators/percent-body-fat-calculator/">
                    المجلس الأمريكي للتمارين الرياضية
                  </a>
                </td>
              </tr>
              <tr>
                <td colSpan="3">
                  <b>تاريخ أخر مراجعة:</b> 28/02/2026
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
    </div>
  );
}
export default BodyFatTable;
